import {
  Text,
  TouchableOpacity,
  View
} from "react-native";
import { FC } from "react";
import dayjs from "dayjs";
import { IGetReportResponseWrapper } from "@/_store/company/contracts";
import RefreshIcon from "@/assets/icons/main/refreshIcon.svg"
import DownloadIcon from "@/assets/icons/main/downloadIcon.svg"
import RiskIndicator, { RiskLevelType } from "@/app/components/RiskIndicator/RiskIndicator";
import Divider from "@/app/components/Divider";

interface IHeaderReport {
  reportData: IGetReportResponseWrapper | undefined;
  companyNameOrPerson: string;
  riskLevel: RiskLevelType | null;
  isProgress?: boolean;
  isShowDownloadRefreshButtons: boolean;
  handleGenerate?: () => void;
  updateReport?: () => void;
}

const HeaderReport: FC<IHeaderReport> = ({
  reportData,
  companyNameOrPerson,
  riskLevel,
  isProgress,
  isShowDownloadRefreshButtons,
  handleGenerate,
  updateReport
}) => {

  return (
    <View className="w-full">
      <View>
        {isProgress
          ? (
            <Text className="text-blue-500 text-base text-center">Формируем отчет ...</Text>
          )
          : (<Text className="text-gray text-sm mb-2 text-center">
            Сформирован {reportData?.created ? dayjs(reportData.created).format("DD MMMM YYYY · HH:mm") : "Нет информации"}
          </Text>)
        }
        <Text className="text-center text-2xl text-black font-medium mb-6">{companyNameOrPerson}</Text>
        {isShowDownloadRefreshButtons && (
          <View className="flex-row gap-3 justify-center mb-6">
            <TouchableOpacity onPress={updateReport} className="flex-col items-center">
              <RefreshIcon className="mb-2"/>
              <Text className="text-center text-gray text-sm">Обновить<br/> отчет</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={handleGenerate} className="flex-col items-center">
              <DownloadIcon className="mb-2"/>
              <Text className="text-center text-gray text-sm">Скачать<br/> полный отчет</Text>
            </TouchableOpacity>
          </View>
        )}
        <View className="mb-6">
          {riskLevel && <RiskIndicator level={riskLevel} />}
        </View>
        <Divider />
      </View>
    </View>
  );
};

export default HeaderReport;
